import { createContext, useContext, useState } from "react";

const TrendContext = createContext();

export const TrendProvider = ({ children }) => {

  const [trendData, setTrendData] = useState({});

  const logValue = (tag, value) => {
    setTrendData(prev => {
      const now = Date.now();

      const existing = prev[tag] || [];

      const updated = [
        ...existing,
        { time: now, value }
      ].slice(-300); // keep last 300 points (~5 mins)

      return {
        ...prev,
        [tag]: updated
      };
    });
  };

  return (
    <TrendContext.Provider value={{ trendData, logValue }}>
      {children}
    </TrendContext.Provider>
  );
};

export const useTrend = () => useContext(TrendContext);